import moment from 'moment';

const Day = ({ currentMessage }: any) => {
    const DATE_FORMAT = 'll';
    return (
        <>
            <div className="talk_day">{moment(currentMessage.createdAt)
                .locale('he')
                .format(DATE_FORMAT)
                .toUpperCase()}</div>

        </>
    )

}

export default Day;